import type { BattleDetail, BattleListResponse } from "../../types/api.generated";

export interface BattleQueryParams {
  page?: number;
  limit?: number;
}

const getAuthHeaders = () => {
  const token = sessionStorage.getItem("tokenUser");
  return { "Content-Type": "application/json", Authorization: `Bearer ${token}` };
};

const getBaseUrl = () => (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export const getBattles = async (params: BattleQueryParams = {}): Promise<BattleListResponse> => {
  const { page, limit } = params;
  const base = getBaseUrl();
  const url = new URL(`${base}/battles`, window.location.origin);
  if (page) url.searchParams.set("page", String(page));
  if (limit) url.searchParams.set("limit", String(limit));

  const response = await fetch(base ? `${base}/battles${url.search}` : `/battles${url.search}`, {
    method: "GET",
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Failed to load battles: ${response.status} ${response.statusText} ${text}`);
  }

  return response.json();
};

export const getNextBattle = async (params: BattleQueryParams = {}): Promise<BattleDetail> => {
  const base = process.env.REACT_APP_BACKEND_URL;
  const response = await fetch(`${base}/battles/next`, {
    method: "GET",
    headers: getAuthHeaders(),
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Failed to load next battle: ${response.status} ${response.statusText} ${text}`);
  }
  return response.json();
}

export const getBattle = async (battleId: string | number): Promise<BattleDetail> => {
  const base = process.env.REACT_APP_BACKEND_URL || "";
  const response = await fetch(`${base}/battles/${battleId}`, {
    method: "GET",
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Failed to load battle: ${response.status} ${response.statusText} ${text}`);
  }

  return response.json();
};

export const getStreamBattle = async (battleId: string | number): Promise<any> => {
  const base = process.env.REACT_APP_BACKEND_URL || "";
  const url = `${base}/battles/${battleId}/stream`;
  const response = await fetch(url, {
    method: "GET",
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Failed to get stream battle upload URL: ${response.status} ${response.statusText} ${text}`);
  }
  return await response.json();
}

export const getMyBattleBet = async (battleId: string): Promise<any> => {
  const base = process.env.REACT_APP_BACKEND_URL || "";
  const url = `${base}/battles/${battleId}/my-bet`;

  const response = await fetch(url, {
    method: "GET",
    headers: getAuthHeaders(),
  });
  if (response.status === 404) {
    return null;
  }
  return await response.json();
}

export const getApiBattle = () => ({ getBattles, getNextBattle, getBattle, getStreamBattle, getMyBattleBet });

export default getApiBattle;
